import { createFileRoute, redirect } from '@tanstack/react-router';

import { PortalShell } from '@/features/portal/portal-shell';
import { supabase } from '@/lib/supabase';

// Layout del Portal Cliente. Todas las sub-rutas /portal/* (excepto
// /portal/login) heredan este shell. Guard: si no hay sesión válida con
// role=client_portal, redirige a /portal/login.

export const Route = createFileRoute('/portal')({
  beforeLoad: async () => {
    const { data } = await supabase.auth.getSession();
    if (!data.session) {
      throw redirect({ to: '/portal/login' });
    }
    const role = (data.session.user.app_metadata as { role?: string } | undefined)?.role;
    if (role !== 'client_portal') {
      throw redirect({ to: '/portal/login' });
    }
  },
  component: PortalShell,
});
